import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getGrn,
  getGrnById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  getPurchaseOrderDetailsById,
  getPurchaseOrderAdditionalChargeList,
  createGrn,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";
import { materialRequestsFrom } from "../../../../../../Utils/constants";

const initialState = {
  grns: [],
  edit: false,
  grn: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingGrn: false,
  loadingNext: false,
  loadingDetails: false,
  purchaseOrder: null,
  purchaseOrderDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate()),
      // requiredDateAd: new NepaliDate().toADasDate().toISOString(),
      unique: uuidv4(),
    },
  ],
  additionalCharges: null,
  // purchaseOrderDetails: null, // commneted for now
  saveAndContinue: false,
  showCreateModal: false,
  selectedPurchaseOrder: null,
  selectedOrderDetails: [],
  selectedAdditionalCharges: [],

  formData: {
    isFromHo: materialRequestsFrom[0], // always true for GRN this is used in order summary
    purchaseOrderMain: null,
    partyAccount: null,
    branch: null,
    partyInvoiceNo: "",
    voucherDateBs: new NepaliDate(),
    termsOfDeliveryPayment: "",
    lcNumber: "",
    ppnNumber: "",
    find: "",
    deliveryDocNumber: "",
    deliveryThrough: "",
    destination: "",
    termsOfDelivery: "",
    refNo: "",
    narration: "",
    discountAmount: "",
    grandTotal: "",
    vatAmount: "",
    documentsAttach: [],

    grnMainPartyDetails: {
      creditDays: "",
      jobNumber: "",
      partyAccount: 0,
    },
    grnMainVehicleDetail: {
      vehicleNo: "",
      builtyNo: "",
      driverName: "",
      driverPhoneNo: "",
      driverAddress: "",
      licenseNo: "",
      transporter: "",
      quantity: 0,
    },
  },
};

export const grnSlice = createSlice({
  name: "grn",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    setMainOrder: (state, action) => {
      state.selectedPurchaseOrder = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.selectedOrderDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },
    setAdditionalDetails: (state, action) => {
      state.selectedAdditionalCharges = action.payload.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    },

    grnDetailsUpdated: (state, action) => {
      state.purchaseOrderDetails = action.payload;
    },

    setPurchaseOrderDetails: (state, action) => {
      state.purchaseOrderDetails = [
        ...action.payload.map((value) => ({
          ...value,
          description: value.product?.name || "",
        })),
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: null,
          altQuantity: "",
          altUnit: null,
          rate: null,
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          // requiredDateAd: new NepaliDate().toADasDate().toISOString(), // Keep if needed later
          unique: uuidv4(),
        },
      ];
    },

    additionalChargesUpdate: (state, action) => {
      state.additionalCharges = action.payload;
    },

    clearSelectedOrderData: (state) => {
      state.selectedPurchaseOrder = null;
      state.selectedOrderDetails = [];
      state.selectedAdditionalCharges = [];
    },
    clearPurchaseOrderDetails: (state, action) => {
      state.purchaseOrderDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          // requiredDateAd: new NepaliDate().toADasDate().toISOString(),
          unique: uuidv4(),
        },
      ];
      state.additionalCharges = null;
    },

    clearGrnDetails: (state) => {
      state.purchaseOrderDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          // requiredDateAd: new NepaliDate().toADasDate().toISOString(),
          unique: uuidv4(),
        },
      ];
      state.purchaseOrderDetails = null;
      state.additionalCharges = null;
    },
    clearAllGrn: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingGrn = false;
      state.grn = null;
      state.selectedPurchaseOrder = null;
      state.selectedOrderDetails = [];
      state.selectedAdditionalCharges = [];

      state.purchaseOrderDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          // requiredDateAd: new NepaliDate().toADasDate().toISOString(),
          unique: uuidv4(),
        },
      ];

      state.additionalCharges = null;
      state.saveAndContinue = false;
      state.selectedPurchaseInvoiceDetails = initialState.selectedPurchaseInvoiceDetails;
      state.grn = initialState.grn;
      state.purchaseOrderDetails = initialState.purchaseOrderDetails;
      state.additionalCharges = initialState.additionalCharges;
      state.selectedPurchaseOrder = initialState.selectedPurchaseOrder;
      state.selectedOrderDetails = initialState.selectedOrderDetails;
      state.selectedAdditionalCharges = initialState.selectedAdditionalCharges;
    },

    saveGrnForm: (state, action) => {
      state.formData = action.payload;
    },
    resetGrnForm: (state, action) => {
      if (action.payload) {
        state.formData = state.purchaseOrder;
      } else {
        state.formData = initialState.formData;
        state.selectedPurchaseInvoiceDetails = initialState.selectedPurchaseInvoiceDetails;
        state.grn = initialState.grn;
        state.purchaseOrderDetails = initialState.purchaseOrderDetails;
        state.additionalCharges = initialState.additionalCharges;
        state.selectedPurchaseOrder = initialState.selectedPurchaseOrder;
        state.selectedOrderDetails = initialState.selectedOrderDetails;
        state.selectedAdditionalCharges = initialState.selectedAdditionalCharges;
      }
    },
  },
  extraReducers: (builder) => {
    // for listing of AdditionalChargeCost
    builder.addCase(createGrn.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createGrn.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createGrn.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getPurchaseOrderAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getPurchaseOrderAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getPurchaseOrderAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });

    // getGrnById
    builder.addCase(getPurchaseOrderDetailsById.pending, (state) => {
      state.loadingDetails = true;
      // state.purchaseOrderDetails = null;
    });
    builder.addCase(getPurchaseOrderDetailsById.fulfilled, (state, action) => {
      state.loadingDetails = false;
    });
    builder.addCase(getPurchaseOrderDetailsById.rejected, (state) => {
      state.false = false;
      // state.purchaseOrderDetails = null;
    });
    builder.addCase(getGrnById.pending, (state) => {
      state.loading = true;
      state.edit = true;
      // state.grn = null;
    });
    builder.addCase(getGrnById.fulfilled, (state, action) => {
      // state.edit = true;
      state.loading = false;
      state.grn = action.payload.data;
      state.purchaseOrderDetails = action.payload.data?.goodReceiptNotesDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
      state.additionalCharges = action.payload.data?.grnMainAdditionalChargeCost;
    });
    builder.addCase(getGrnById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.grn = null;
    });
    builder.addMatcher(
      isAnyOf(getGrn.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingGrn = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getGrn.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingGrn = false;
        state.grns = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGrn.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingGrn = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setMainOrder,
  setOrderDetails,
  setAdditionalDetails,
  grnDetailsUpdated,

  setPurchaseOrderDetails,
  additionalChargesUpdate,
  clearSelectedOrderData,
  clearPurchaseOrderDetails,
  clearGrnDetails,
  clearAllGrn,
  saveGrnForm,
  resetGrnForm,
} = grnSlice.actions;

export default grnSlice.reducer;
